import {
	formatGroupeParlementaire,
	formatGroupeVotantVote,
	formatGroupeVotantTotal,
	formatCell,
	formatRow,
} from "../formatters";
import { VoteIcon } from "@logora/parliament.icons.regular_icons";

const columns = [
	{
		header: "Groupe politique",
		accessorKey: "organeRef",
		cell: (info) => formatGroupeParlementaire(formatCell(info)),
	},
	{
		header: "Pour",
		accessorKey: "pour",
		cell: (info) => formatGroupeVotantVote(formatRow(info), "pour"),
	},
	{
		header: "Contre",
		accessorKey: "contre",
		cell: (info) => formatGroupeVotantVote(formatRow(info), "contre"),
	},
	{
		header: "Abstention",
		accessorKey: "abstentions",
		cell: (info) => formatGroupeVotantVote(formatRow(info), "abstentions"),
	},
	{
		header: "Nombre de votants",
		accessorKey: "nombreMembresGroupe",
		cell: (info) => formatGroupeVotantTotal(formatRow(info)),
		enableSorting: false,
	},
	{
		header: "Nombre de membres",
		accessorKey: "nombreMembresGroupe",
	},
];

export const groupeVotantDataset = {
	key: "groupesVotants",
	name: "Groupes politiques",
	columns: columns,
	searchTable: "organeRef",
	showSearch: false,
	perPage: 20,
	include: ["organeRef"],
	icon: <VoteIcon width={20} height={20} />,
	rowRedirect: (item) => `/parliament/organes/${item.organeRefUid}`,
};
